import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" tekrevol_dark_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services">
                            <h2>PHP Development Services To Help You Acquire A Competitive Edge In The Market</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol’s prime focus with any of its development solutions, including PHP development services, is to deliver excellence and provide long-term value to all its clients around the globe. Our expert PHP developers for hire have years of experience developing great backend solutions, helping small, mid-market, and enterprise-grade businesses achieve their business objectives. There’s little room for error with our PHP development services.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;